import { useState } from "react";
import getMessage from "../../utils/getMessage";
import LoadSpinnerContainer from "../LoadSpinnerContainer";
import config from "../../config";
import { FormattedMessage } from "react-intl";
import { localizedNotifyError, localizedNotifySuccess } from "../../utils/notify";
import { turnResponseErrorStringToLocalizationKey } from "../../utils/validation";
import { updateCurrentUserWithPartial } from "../../store/actions/user";
import { useDispatch, useSelector } from "react-redux";
import { Field, Form, Formik } from "formik";
import { object } from "yup";
import DigiraatiAvatarInput, { DigiraatiAvatarInputValidationSchema } from "../../views/Auth/Fields/AvatarInput";
import { getUser } from "../../store/selectors/user";

const UserUpdateAvatar = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [changedSuccessfully, setChangedSuccessfully] = useState(false);

  const user = useSelector(state => getUser(state))
  const dispatch = useDispatch();

  const onSubmitAvatar = async (values, setFieldError) => {
    setIsSubmitting(true);
    const sentAvatar = values['avatar'];
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${config.apiBaseUrl}/v1/users/current/`, {
      method: "PATCH",
      headers: {
        Authorization: "Token " + token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        avatar: sentAvatar,
      }),
    });
    if (response.ok) {
      dispatch(updateCurrentUserWithPartial({avatar: sentAvatar}));
      localizedNotifySuccess('userUpdateAvatarSuccess')
      setChangedSuccessfully(true);
    } else {
      try {
        const data = await response.json();
        if (data.avatar) {
          const errorKey = turnResponseErrorStringToLocalizationKey(data.avatar[0], 'userUpdateAvatarError');
          localizedNotifyError(errorKey);
          setFieldError('avatar', errorKey)
        } else if (data.status) {
          const errorKey = turnResponseErrorStringToLocalizationKey(data.status, 'userUpdateAvatarError');
          localizedNotifyError(errorKey);
        } else {
          localizedNotifyError('userUpdateAvatarError');
        }
      } catch (_e) {
        localizedNotifyError('userUpdateAvatarError');
      }
    }
    setIsSubmitting(false);
  }

  return (
    <div className="hds-form hds-form--login" style={{paddingTop: '0'}}>
      <h3>
        <FormattedMessage id="userUpdateAvatar" />
      </h3>
      {!changedSuccessfully && <div>
      <fieldset className="hds-fieldset">
        <p>
          <FormattedMessage id="userUpdateAvatarDescription" />
        </p>
          <Formik
            initialValues={{avatar:user.avatar}}
            validationSchema={object().shape({...DigiraatiAvatarInputValidationSchema})}
            >
              {({
                values,
                isValid,
                onSubmit = () => {},
                setFieldError,
              }) => (
                <Form>
                  <Field
                    name="avatar"
                    required
                    component={DigiraatiAvatarInput}
                  />
                  <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <LoadSpinnerContainer isLoading={isSubmitting}>
                      <button
                        type="button"
                        onClick={() => onSubmitAvatar(values, setFieldError)}
                        className="digi-button"
                        disabled={!isValid || isSubmitting}
                      >
                        {getMessage('chooseDo')}
                      </button>
                    </LoadSpinnerContainer>
                  </div>
                </Form>
              )}
          </Formik>
      </fieldset>
      
      </div>}
      {changedSuccessfully && <p><FormattedMessage id="userUpdateAvatarSuccess" /></p>}
    </div>
  );
}


export default UserUpdateAvatar;